import { takeEvery, fork, put, all, call } from "redux-saga/effects";
import { CHECK_LOGIN, LOGOUT_USER, FORCE_LOGOUT, CLEAR_ALL_LOGIN_MESSAGES } from "./actionTypes";
import { apiError, clearAllLoginMessagesSuccessful, loginUserSuccessful } from "./actions";
import { postLogin } from "../../helpers/auth_helper";
import { jwtDecode } from "jwt-decode";
import EncryptPassword from "../../components/EncryptPassword";

function* loginUser({ payload: { user, history } }) {
  try {
    const response = yield call(postLogin, {
      username: user.userName,
      password: EncryptPassword(user.password),
      // accessToken: user.idToken
    });
    console.log("Login Response :: ", response);
    if (response && response.status === 200) {
      const { idToken, refreshToken } = response;
      console.log("--==response", response, idToken);
      console.log("Refresh Token", refreshToken);
      const decoded = jwtDecode(idToken);
      const { exp } = decoded;
      console.log("jwt_decode ::: > ", decoded, exp);
      localStorage.setItem("authUser", JSON.stringify(response));
      localStorage.setItem("Id Token", JSON.stringify(exp));
      localStorage.removeItem("lastActiveRoute");
      yield put(loginUserSuccessful(response));
      history.push("/details");
    } else {
      let message;
      if (response.data.message) {
        message = response.data.message;
      } else {
        message = response.data;
      }
      yield put(apiError({ message: message }));
    }
  } catch (error) {
    console.log("Error :: ", error);
    if (error.response) {
      let message;
      if (error.response.data?.message) {
        message = error.response.data?.message;
      } else {
        message = error.response.data;
      }
      yield put(apiError({ message: message }));
    } else if (error.request) {
      yield put(apiError({ message: "No response is received" }));
    } else {
      yield put(apiError({ message: error?.message }));
    }
  }
}

function* logoutUser({ payload: { history } }) {
  try {
    localStorage.removeItem("authUser");
    history.push("/login");
  } catch (error) {
    yield put(apiError(error));
  }
}
function* forceLogout() {
  try {
    localStorage.removeItem("authUser");
  } catch (error) {
    yield put(apiError(error));
  }
}

export function* clearAllLoginMessages() {
  console.log("Saga: clear all login messages");
  yield put(clearAllLoginMessagesSuccessful());
}

export function* watchUserLogin() {
  yield takeEvery(CHECK_LOGIN, loginUser);
}

export function* watchUserLogout() {
  yield takeEvery(LOGOUT_USER, logoutUser);
}
export function* watchForceLogout() {
  yield takeEvery(FORCE_LOGOUT, forceLogout);
}

export function* watchClearAllLoginMessages() {
  yield takeEvery(CLEAR_ALL_LOGIN_MESSAGES, clearAllLoginMessages);
}

function* loginSaga() {
  yield all([fork(watchUserLogin), fork(watchUserLogout)]);
  yield all([fork(watchForceLogout)]);
  yield all([fork(watchClearAllLoginMessages)]);
}

export default loginSaga;
